/* eslint-disable camelcase */
import Vue, { VueConstructor } from 'vue'
import * as db from '@shared/types/database'
import UserDiscoveryIcon from '@/assets/img/classic-test-type-icons/record-voice-over.svg?inline'
import CompetitiveOverviewIcon from '@/assets/img/classic-test-type-icons/group-work.svg?inline'
import ConceptIcon from '@/assets/img/classic-test-type-icons/widgets.svg?inline'
import ComparisonIcon from '@/assets/img/classic-test-type-icons/swap-vert.svg?inline'
import UXRefinementIcon from '@/assets/img/classic-test-type-icons/select-all.svg?inline'
import UsabilityIcon from '@/assets/img/classic-test-type-icons/screen-rotation.svg?inline'

export interface ClassicTestType {
  name: string
  classic: boolean
  html: string
  formName: string
  icon: VueConstructor<Vue>
  title_text: string
  title_placeholder: string
  description_title?: string
  description_placeholder?: string
  required: Array<keyof NewInsight>
  optional: Array<keyof NewInsight>
  required_for_template?: string[]
}

export interface NewInsight {
  title?: string
  objective?: string
  decisionContext?: string
  customerQuestions?: string
  description?: string
  concept_assets?: Record<string, db.Prototype>
  comparison?: Record<string, db.Prototype>
  comparison_type?: string
  client_name?: string
  prototypes?: Record<string, db.Prototype>
  additional_info?: string
  draft?: boolean
}

const testTypes: ClassicTestType[] = [
  {
    name: 'User Discovery',
    classic: true,
    html: 'User<br>Discovery',
    formName: 'user-discovery',
    icon: UserDiscoveryIcon,
    title_text: 'What would you like to learn about your users?',
    title_placeholder: 'For example: How often do my users brush their teeth? or How do my users currently find car insurance? or What tools or resources do my users use to shop online?',
    required: ['title'],
    optional: ['additional_info', 'prototypes']
  },
  {
    name: 'Competitive Overview',
    classic: true,
    html: 'Competitive<br>Overview',
    formName: 'competitive-overview',
    icon: CompetitiveOverviewIcon,
    title_text: 'What would you like to learn about your competitors?',
    title_placeholder: 'For example: Who do our users consider our competitors? or Which company has a more interesting feature set, Uber or Lyft?',
    required: ['title'],
    optional: ['additional_info', 'prototypes']
  },
  {
    name: 'Product Concept Testing',
    classic: true,
    html: 'Concept',
    formName: 'product-concept-testing',
    icon: ConceptIcon,
    title_text: 'What would you like to learn about this concept?',
    title_placeholder: 'For example: How interested are our users in this concept? or How would building this product impact our brand perception?',
    description_title: 'What concept would you like to present to your audience?',
    description_placeholder: 'For example: An app that lets you run a free background check on yourself.',
    required: ['title', 'description', 'concept_assets'],
    optional: ['additional_info', 'prototypes']
  },
  {
    name: 'Comparison',
    classic: true,
    html: 'Comparison',
    formName: 'comparison',
    icon: ComparisonIcon,
    title_text: 'What would you like to learn?',
    title_placeholder: 'For example: Which feature do users find most important? Or, Which design do users find most visually appealing?',
    description_placeholder: 'Provide an introduction to what you\'d like to test. This will be presented to users prior to testing.',
    required: ['title', 'description', 'comparison', 'comparison_type'],
    optional: ['additional_info', 'prototypes']
  },
  {
    name: 'UX Refinement',
    classic: true,
    html: 'UX<br>Refinement',
    formName: 'ux-refinement',
    icon: UXRefinementIcon,
    title_text: 'What user experience would you like to refine?',
    title_placeholder: 'For example: Which UX do users prefer when changing their password? or What interface changes can we make to encourage users to share our content socially?',
    required: ['title'],
    required_for_template: ['description', 'title', 'concept_assets'],
    optional: ['additional_info', 'prototypes']
  },
  {
    name: 'Usability',
    classic: true,
    html: 'Usability',
    formName: 'usability-testing',
    icon: UsabilityIcon,
    title_text: 'What would you like to learn?',
    title_placeholder: 'For example: What parts of my interface do my users think are confusing? or How do my users accomplish a specific task on my website?',
    required: ['title', 'description'],
    optional: ['additional_info', 'prototypes']
  }
]

export default testTypes
